import _ from 'lodash';
import Service from './abstract';

class FraudPrevention extends Service {
    constructor () {
        super('users/fraudcontrol');
    }

    getRules (options) {
        return this.get({
            url: `${this.basePath}/rules`,
            qs: _.defaultsDeep(options, { order: 'created_at-DESC' })
        });
    }
}

export default new FraudPrevention();
